// assets/product-custom-property.js - Version alternative
import { AKComponent } from '@theme/component';

/**
 * A custom element that manages product custom properties
 */
class ProductCustomProperty extends AKComponent {
  
  /**
   * Called when the component is connected to the DOM
   */
  connectedCallback() {
    super.connectedCallback();
    
    // Find elements using simple selectors
    this.textInput = this.querySelector('input[type="text"], textarea');
    this.characterCount = this.querySelector('.c-character-count');
    
    if (this.textInput && this.characterCount) {
      // Initialize the character count
      this.updateCharacterCount();
      
      // Add event listener
      this.textInput.addEventListener('input', () => this.updateCharacterCount());
    } else {
      console.warn('Elements not found:', {
        textInput: !!this.textInput,
        characterCount: !!this.characterCount
      });
    }
  }
  
  /**
   * Handle input events (called by Shopify's event system)
   */
  handleInput() {
    this.updateCharacterCount();
  }
  
  /**
   * Update the character count display
   */
  updateCharacterCount() {
    if (!this.textInput || !this.characterCount) return;
    
    const currentLength = this.textInput.value.length;
    const maxLength = parseInt(this.textInput.getAttribute('maxlength') || '0') || 0;
    
    const template = this.characterCount.getAttribute('data-template');
    if (!template) return;
    
    // Replace placeholders in template
    const updatedText = template
      .replace('[current]', currentLength.toString())
      .replace('[max]', maxLength.toString());
    
    this.characterCount.textContent = updatedText;
    
    // Add visual feedback when approaching limit
    const percentage = maxLength > 0 ? (currentLength / maxLength) * 100 : 0;
    
    if (percentage >= 90) {
      this.characterCount.style.color = 'var(--color-error, #e74c3c)';
      this.characterCount.style.opacity = '1';
    } else if (percentage >= 80) {
      this.characterCount.style.color = 'var(--color-warning, #f39c12)';
      this.characterCount.style.opacity = '1';
    } else {
      this.characterCount.style.color = 'var(--color-foreground)';
      this.characterCount.style.opacity = '0.5';
    }
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);